export default "__VITE_ASSET__3e528a8a__"